import(/* webpackMode: "eager", webpackExports: ["AdminTrialBadge"] */ "/var/www/sahha/apps/web/src/components/admin/AdminTrialBadge.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/sahha/apps/web/src/components/analytics/TrackedAction.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BookingUnavailable"] */ "/var/www/sahha/apps/web/src/components/booking/BookingUnavailable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FavoriteButton"] */ "/var/www/sahha/apps/web/src/components/physician/FavoriteButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyMapsEmbed"] */ "/var/www/sahha/apps/web/src/components/physician/LazyMapsEmbed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MedecinScrollHeader"] */ "/var/www/sahha/apps/web/src/components/physician/MedecinScrollHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PhysicianViewedTracker"] */ "/var/www/sahha/apps/web/src/components/physician/PhysicianViewedTracker.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/sahha/apps/web/src/components/physician/ReviewFormButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StickyBookingCTA"] */ "/var/www/sahha/apps/web/src/components/physician/StickyBookingCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StickyTabNav"] */ "/var/www/sahha/apps/web/src/components/physician/StickyTabNav.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/sahha/apps/web/src/components/physician/TeleconsultLiveBadge.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/sahha/apps/web/src/components/physician/UnclaimedCallButton.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/sahha/apps/web/src/components/search/PhysicianAvatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/sahha/node_modules/.pnpm/next-intl@4.9.1_next@16.2.4_@playwright+test@1.59.1_react-dom@19.2.5_react@19.2.5__react@19.2_l5grzow3fqit65i7mrylfy7i7e/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/sahha/node_modules/.pnpm/next-intl@4.9.1_next@16.2.4_@playwright+test@1.59.1_react-dom@19.2.5_react@19.2.5__react@19.2_l5grzow3fqit65i7mrylfy7i7e/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/var/www/sahha/node_modules/.pnpm/next@16.2.4_@playwright+test@1.59.1_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/www/sahha/node_modules/.pnpm/next@16.2.4_@playwright+test@1.59.1_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
